export default __webpack_public_path__ + "static/media/Beard_9_C2.4ca1c044.svg";